<template>
  <div class="p-2 pl-4 pr-4 main-container">
        <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading> 
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
        <div class="divSubtitulo d-flex justify-content-between">
          <p class="textSubtitulo" style="padding-left: 10px; font-size: large">
            Caja Cobro
          </p>
          <p
            class="textSubtituloCodigo"
            style="padding-right: 10px; font-size: large"
          >
            CJ_01_COBRO SESION
          </p>
        </div>

        <div class="mt-5">
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex">
            <em class="check m-0 mr-2"></em>
            <p class="success m-0">Pago realizado con éxito</p>
          </div>

          </div>

          <b-row class="m-0 text-left mt-5" style="height:50%">
            <b-col sm="12" md="12" lg="6" xl="6" class="m-0 p-0">
              <p class="title">Información del paciente</p>
              <div class="mt-4" style="line-height: 2.5;">
                <p>Nombre: <span>{{ informacionSesion.paciente }}</span></p>
                <p>ID Paciente: <span>{{ informacionSesion.idPaciente }}</span></p>
                <p>Clínica: <span>{{ informacionSesion.clinica }}</span></p>
                <p>Odontólogo: <span>{{ informacionSesion.doctor }}</span></p>
              </div>
            </b-col>
            <b-col sm="12" md="12" lg="6" xl="6" class="borde-izq">
              <p class="title">Recibo de pago no. {{ recibo.idRecibo }}</p>
               <div class="mt-4" style="line-height: 2.5;">
                <p>Total a pagar: {{ recibo.montoPagar | monedaDecimales}}</p>
                <p>Total pagado: {{ recibo.total | monedaDecimales}}</p>
              </div>
              
            </b-col>
          </b-row>

           <div class="d-flex justify-content-center">
              <b-row class="btns-apilados">
                <b-col sm="12" md="4" lg="4" xl="4">
                  <b-button class="btn-caja" variant="outline-primary" pill @click="imprimir()">
                    <div class="d-flex justify-content-center">
                      <em class="imprimir mr-2"></em>
                      <p class="m-0">Imprimir</p>
                    </div>
                  </b-button>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                   <b-button class="btn-caja" v-if="idFactura === null && $localStorageService.can('BT_facturar')" variant="outline-primary" pill @click="cualFactura()">
                  <div class="d-flex justify-content-center">
                    <em class="documento mr-2"></em>
                    <p class="m-0">Facturar</p>
                  </div>
                </b-button>
                  <b-button class="btn-caja" v-if="idFactura != null" variant="outline-primary" @click="imprimirFactura()">
                  <div class="d-flex justify-content-center">
                    <em class="imprimir mr-2"></em>
                    <p>Imprimir Factura</p>
                  </div>
                </b-button>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                  <b-button class="btn-caja" variant="outline-primary" pill @click="modalRecibo()">
                  <div class="d-flex justify-content-center">
                    <em class="envio mr-2"></em>
                    <p class="m-0">Enviar</p>
                  </div>
                </b-button>
                </b-col>              
              </b-row>
           </div>

           <div class="d-flex justify-content-center mb-4 pb-5">
             <b-row class="d-flex btns-apilados">
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-button class="btn-cerrarPago btn-caja" variant="primary" @click="cerrarPago()">Cerrar pago</b-button>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-button class="btn-caja" variant="outline-secondary" @click="cancelarRecibo()">Cancelar recibo</b-button>
              </b-col>
                
              </b-row>
           </div>
        </div>
      </div>

    <b-modal
        v-model="showModal"
        title="Datos Fiscales"
        size="lg"
        centered
    >
      <div fluid>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group @input="listaFiscal"  id="tipo" v-model="datoFiscal.tipoPersona"
                                  name="tipo">
                <b-form-radio :value="2">Fisica</b-form-radio>
                <b-form-radio :value="1">Moral</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="rfc">RFC
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="rfc" name="rfc" placeholder="RFC"
                              v-model="$v.datoFiscal.rfc.$model"
                              @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                              :state="validateState('rfc')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group>
          <label for="regimen">Regimen Fiscal
            <validacion/>
          </label>
          <b-input-group size="sm" class="mb-2">
            <b-input-group-prepend is-text>
              <b-icon icon="menu-button-wide"></b-icon>
            </b-input-group-prepend>
            <b-form-select id="regimen" name="regimen" placeholder="Regimen Fiscal"
                           v-model="$v.datoFiscal.regimenFiscal.$model"
                           :options="regimenFiscales"
                           value-field="idRegimenFiscal"
                           text-field="nombre"
                           :state="validateState('regimenFiscal')"
            ></b-form-select>

          </b-input-group>
        </b-form-group>

        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="nombre">Nombre(s)
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="$v.datoFiscal.nombre.$model"
                              :state="validateState('nombre')"
                              id="nombre" name="rfc" placeholder="Nombre"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 1">
          <b-col>
            <b-form-group>
              <label for="nombre">Nombre de la razón social
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="$v.datoFiscal.nombreCompleto.$model"
                              :state="validateState('nombreCompleto')"
                              id="nombre" name="rfc" placeholder="Nombre"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="paterno">Apellido paterno
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="paterno" name="paterno" placeholder="Apellido paterno"
                              v-model="$v.datoFiscal.paterno.$model"
                              :state="validateState('paterno')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="materno">Apellido materno
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="materno" name="materno" placeholder="Apellido materno"
                              v-model="$v.datoFiscal.materno.$model"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="correo">Correo electrónico
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="email" id="correo" name="correo" placeholder="Correo"
                              v-model="$v.datoFiscal.correo.$model"
                              :state="validateState('correo')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5>Dirección <span class="text-secondary"><small>(Opcional)</small></span></h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="calle">Calle
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="calle" name="calle" placeholder="Calle" v-model="datoFiscal.calle"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="numero">Número
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="numero" name="numero" placeholder="Número" v-model="datoFiscal.numero"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="cp">CP
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="cp" name="cp" placeholder="CP" v-model="$v.datoFiscal.cp.$model"
                              :state="validateState('cp')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="colonia">Colonia
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>

                <v-select
                    id="colonia"
                    style="width: 90%"
                    name="colonia"
                    label="nombreLocalidad"
                    placeholder="Selecciona una colonia"
                    v-model="datoFiscal.colonia"
                    :reduce="(nom) => nom.nombreLocalidad"
                    :options="localidades"
                ></v-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="pais">País de residencia
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="pais" name="pais" placeholder="País" v-model="datoFiscal.pais"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="estado">Estado
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="estado" name="estado" placeholder="Estado" v-model="datoFiscal.estado"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
<!--Termina modal para agregar datos Fiscales-->
    <b-modal v-model="showModalFactura" title="Factura" centered>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form-group
                id="idfactura"
                label="RFC para factura:"
                label-for="input-1"
            >
              <b-form-select v-model="factura.idDatosFiscales" class="mb-3">
                <b-form-select-option
                    v-for="item in datosFiscales"
                    :key="item.rfc"
                    :value="item"
                >{{ item.rfc }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="idfactura"
                label="Nombre de la Razón Social:"
                label-for="input-1"
            >
              <p v-if="factura.idDatosFiscales != null"> {{factura.idDatosFiscales.nombreCompleto}}</p>
              <p v-else></p>
            </b-form-group>

            <b-form-group label="Correo Electrónico:" label-for="input-2">
                  <p v-if="factura.idDatosFiscales != null"> {{factura.idDatosFiscales.correo}}</p>
                  <p v-else></p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="input-group-1"
                label="Uso de CFDI:"
                label-for="input-1"
            >
              <b-form-select v-model="factura.cfdi" class="mb-3">
                <b-form-select-option value="D01"
                >Honorarios médicos, dentales y gastos hospitalarios
                  (D01)</b-form-select-option
                >
                <b-form-select-option value="G03"
                >Gastos en general (G03)</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <span style="font-size: x-small; color: darkgray">Opciones avanzadas</span>
        <hr style="margin-top: 0.1rem">
        <b-row>
          <b-col>
            <b-form-checkbox
                id="checkbox-1"
                v-model="factura.datosPaciente"
                name="checkbox-1"
            >
              Mostrar datos del paciente
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
                id="checkbox-2"
                v-model="factura.desglosada"
                name="checkbox-2"
            >
              Factura desglosada
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
            variant="outline-primary"
            :disabled="loaderFacturar"
            @click="realizarFactura()"
        >
          <span v-if="!loaderFacturar">Facturar</span>
          <span v-if="loaderFacturar">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
            variant="outline-danger"
            :disabled="loaderFacturar"
            @click="cerrarModal()"
        >Cancelar
        </b-button>
      </div>
    </b-modal>


    <b-modal
        v-model="modalMotivo"
        title="Seleccionar motivo"
        centered
        size="lg"
        no-close-on-backdrop
    >
      <b-col>
        <label class="mr-sm-2" for="motivo">Motivo * </label>
        <v-select
            id="motivo"
            label="descripcion"
            v-model="motivo"
            :options="motivosFiltrados"
            required
            placeholder="Seleccionar motivo"
        ></v-select>
      </b-col>
      <div slot="modal-footer">
        <b-button
            variant="outline-primary"
            :disabled="loaderCancelarRecibo"
            @click="cancelar()"
        >
          <span v-if="!loaderCancelarRecibo">Guardar</span>
          <span v-if="loaderCancelarRecibo">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
        </b-button>
        <b-button
            variant="outline-danger"
            :disabled="loaderCancelarRecibo"
            @click="cerrarModal()"
        >Cancelar
        </b-button
        >
      </div>
    </b-modal>

    <b-modal
        v-model="modalEnvio"
        title="Enviar recibo por correo"
        centered
        size="lg"
        no-close-on-backdrop
        hide-footer
    >
      <div>
        <CorreoPaciente :informacionSesion="informacionSesion" :idRecibo="idRecibo" :idPti="idPti" @cerrarModalRecibo="cerrarModalRecibo"/>
      </div>  
    </b-modal>


  </div>
</template>

<script>
import {email, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";
import CorreoPaciente from "./CorreoPaciente.vue";
export default {
  name: "pagoRealizado",
  props: {
    idRecibo: null,
    idPaciente: null,
    idFactura: null,
    etapaRecibo: null,
    informacionSesion: null,
    idPti: null,
  },
  components: {
    CorreoPaciente
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      recibo: {
        idRecibo: null,
        totaplPagado: 0,
        aplicacionSaldo: 0,
        totalAbonado: 0,
        totalPagoAdeudo: 0,
        formasDepago: [],
        total: 0,
        facturado: false
      },

      tieneCp: false,
      showModalFactura: false,
      showModal: false,
      loaderAcciones: false,
      datoFiscal: {
        idPaciente: null,
        idDatosFiscales: null,
        nacionalidad: null,
        rfc: null,
        regimen: null,
        tipoPersona: 1,
        nombre: null,
        nombreCompleto: null,
        paterno: null,
        materno: null,
        calle: null,
        numero: null,
        colonia: null,
        cp: null,
        pais: null,
        estado: null,
        correo: null,
        regimenFiscal: null
      },
      localidades: [],
      datosFiscales: [],
      regimenFiscales:[],
      factura: {
        recibos: [],
        idDatosFiscales: null,
        cfdi: null,
        idClinica: null,
        datosPaciente: false,
        desglosada: false,
        permiso: null
      },
      loaderFacturar: false,
      loaderCancelarRecibo: false,
      motivos:[],
      motivosFiltrados:[],
      modalMotivo: false,
      motivo: null,
      idSesion: null,
      montoFinanciar: null,
      totalFinalVista: null,
      loading: false,
      modalEnvio: false,
    }
  },
  validations() {
    if (this.datoFiscal.tipoPersona === 2) {
      return {
        datoFiscal: {
          rfc: {required, minLength: minLength(13), maxLength: maxLength(13)},
          regimenFiscal: {required},
          nombre: {required},
          paterno: {required},
          materno: {},
          correo: {required, email},
          cp: {numeric, maxLength: maxLength(5), required},
        }
      }
    } else {
      return {
        datoFiscal: {
          rfc: {required, minLength: minLength(12), maxLength: maxLength(12)},
          regimenFiscal: {required},
          nombreCompleto: {required},
          regimen: {required},
          correo: {required, email},
          cp: {numeric, maxLength: maxLength(5), required},
        }
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idSesion = this.$route.params.idSesion;
    this.datoFiscal.idPaciente = this.idPaciente;
    this.obtenerInformacionRecibo();
    this.obtenerMotivos();
    this.obtenerRfcs();
    this.listaFiscal();
    this.montoFinanciar = localStorage.getItem("montoFinanciar");
    this.totalFinalVista = localStorage.getItem("totalFinalVista");
  },
  methods:{
    cerrarModalRecibo(){
      this.modalEnvio = false;
    },
    modalRecibo(){
      this.modalEnvio = true;
    },

    listaFiscal() {
      const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
      this.$http.post(this.$api + 'catalogos/regimenFiscal/obtener/activo', parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.regimenFiscales = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },
    obtenerInformacionRecibo(){
      const parametros = {idRecibo: this.idRecibo}
      this.$http.post(this.$api + "caja/obtener-informacion/recibo", parametros).then((res) => {
        if (res.status === 200) {
          this.recibo = res.data.data;
          this.recibo.aplicaWizzardPTI = this.recibo.idTipoRecibo === 1 || this.recibo.idTipoRecibo === 6 || this.recibo.idTipoRecibo === 7 || this.recibo.idTipoRecibo === 10;
        }
      });
    },
    obtenerMotivos() {
      this.$http.get(this.$api + "catalogos/motivos").then((respuesta) => {
        if (respuesta.data.data) {
          this.motivos = respuesta.data.data;
        }
      });
    },
    obtenerRfcs() {
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "fiscales/obtener/datosFiscales", params )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosFiscales = respuesta.data.data.filter(t => t.activo);
            }
          });
    },
    cancelarRecibo() {
     if(this.recibo.facturado == true){
        this.$swal({
          icon: "warning",
          text: "No se puede cancelar un recibo ya facturado",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        return false;
      }
      this.motivosFiltrados = [];
      this.motivo = null;
      this.motivosFiltrados = this.motivos.filter(
          (value) => value.accion === 3
      );
      this.modalMotivo = true;
      this.etapaRecibo = false;
    },
    cancelar(){
      if (this.motivo == null) {
        this.$swal({
          icon: "warning",
          text: "Seleccione un motivo",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        return false;
      }

      if (this.recibo.aplicaWizzardPTI) {
        this.$swal.fire({
          title: "¿Estas seguro de realizar la cancelación del pago?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.realizarCancelacionPresupuestoCaja();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      } else {
        this.realizarCancelacionPresupuestoCaja();
      }
    },
    realizarCancelacionPresupuestoCaja() {
      this.loaderCancelarRecibo = true;
      const params = {
        idRecibo: this.idRecibo,
        idMotivo: this.motivo.idMotivo
      }
      this.$http
          .post(
              this.$api +
              "fiscales/recibo/cancelar", params )
          .then((respuesta) => {
            if (respuesta.data.data) {
              if (this.ptiReplica != null && !this.ptiReplica) {
                this.cancelarPresupuestoSDI();
              }

              if (this.recibo.aplicaWizzardPTI) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "Debes realizar una corrección de pago de PTI",
                }).then(() => {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "Se canceló el recibo",
                    timer: 4000,
                  })

                  this.$emit("eliminarRecibo", true);
                });
              } else {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "Se canceló el recibo",
                  timer: 4000,
                })

                this.$emit("eliminarRecibo", false);
              }
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Error al cancelar el recibo",
              });
            }
          }).catch(error => {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.response.data.message,
        });
      }).finally(() => {
        this.loaderCancelarRecibo = false
      });
    },
    cancelarPresupuestoSDI() {
      const url = this.$api + "pti/cancelar/sdi";
      const parametros = {
        idPti: this.idPti,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };

      this.$http.put(url, parametros).then(() => {
      });
    },
    guardar() {
        this.$v.datoFiscal.$touch();
        if (this.$v.datoFiscal.$anyError) {
          return;
        }
        if (!this.$v.datoFiscal.$invalid) {
          this.loaderAcciones = true;
          this.nombre();
          this.$http
              .post(this.$api + "fiscales/guardar/datosFiscales", this.datoFiscal)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  this.obtenerRfcs();
                  this.showModal = false;
                  this.showModalFactura = true;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "Los datos se guardó correctamente",
                  });
                }
              })
              .catch( (reason) => {
                this.$swal.fire({
                  icon: "success",
                  title: "¡Muy Bien!",
                  text: reason.response.data.message,
                });
              })
              .finally(() => {
                this.loaderAcciones = false;
              });
        }
    },
    nombre() {
      if (this.datoFiscal.tipoPersona === 1) {
        this.datoFiscal.nombre = "";
        this.datoFiscal.paterno = "";
        this.datoFiscal.materno = "";
        this.datoFiscal.nombreCompleto = this.datoFiscal.nombreCompleto.trimStart();
        this.datoFiscal.nombreCompleto = this.datoFiscal.nombreCompleto.trimEnd();
      } else {
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimStart();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimStart();
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimEnd();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimEnd();
        if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trimStart();
          this.datoFiscal.materno = this.datoFiscal.materno.trimEnd();
        }
      }
    },
    imprimir() {
      this.loaderRecibo = true;
      this.loading = true;

      const envio = {
        idRecibo: this.idRecibo,
        idPti: this.idPti,
        horas: this.$horas(),
        esReciboPti: false
      };
      if (this.pti !== null && this.pti === true) {
        envio.esReciboPti = true;
        this.$http
            .post(this.$api + "reportes/recibo", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data;
                this.descargar("Recibo-" + this.idRecibo + new Date(), datos);
              }
            })
            .finally(() => {
              this.loaderRecibo = false;
                this.loading = false;
            });
      } else {
        this.$http
            .post(this.$api + "reportes/recibo", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data;
                this.descargar("Recibo-" + this.idRecibo + new Date(), datos);
              }
            })
            .finally(() => {
              this.loaderRecibo = false;
              this.loading = false;
            });
      }

    },
    validateState(name)
    {
      const {$dirty, $error} = this.$v.datoFiscal[name];
      return $dirty ? !$error : null;
    },
    imprimirFactura() {
      const parametros = {idFactura: this.idFactura}
      this.$http
          .post(this.$api + "reportes/factura/erp", parametros)
          .then((respuesta) => {
            if (respuesta.data.data === null ){
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: 'No se encontro la url de la factura',
              });
              return false
            }else {
              window.open(respuesta.data.data);
            }
          });
    },
    descargarFactura(datos) {
      const pdf = datos.pdf;
      const xml = datos.xml;
      const folio = datos.uid;
      const zip = new JSZip();
      zip.file(folio + ".xml", xml, { base64: false });
      zip.file(folio + ".pdf", pdf, { base64: true });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, folio + ".zip");
      });
    },
    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      link.click();
    },

    buscarCp() {
      const params = {
        codigoPostal: this.datoFiscal.cp
      }
      this.$http
          .post(this.$api + "localidad/postales", params)
          .then((respuesta) => {
            if (respuesta.status === 200) {
              if (respuesta.data.data.length > 0) {
                this.localidades = respuesta.data.data;
                this.datoFiscal.estado = this.localidades[0].nombreEstado;
                this.datoFiscal.pais = "MÉXICO";
              }
            }
          });
    },

    cualFactura() {
      if (this.datosFiscales.length > 0) {
        this.showModalFactura = true;
      } else {
        this.showModal = true;
      }
      this.factura.recibos = [];
      this.factura.recibos.push(this.idRecibo);
      this.factura.idClinica = this.$localStorageService.getIdClinica();
      this.factura.permiso = this.$localStorageService.getAuthorities().find(ele => ele == 'Fac_01_unAnio_conta');
      if(this.factura.permiso === undefined){
          this.factura.permiso = null;
      }
    },
    cerrarModal() {
      this.showModalFactura = false;
      this.showModal = false;
      this.modalMotivo = false;
    },
    realizarFactura() {
      if (this.factura.recibos.length > 0) {
        this.$swal.fire({
            title: "<h6><b>Estos datos son los que se enviaran <br>¿Estas seguro de facturar?</b></h6>",
            html: '<h6>RFC: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.rfc +'</small></span></h6>'+
            '<h6 class="mr-3">Razón Social: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.nombreCompleto +'</small></span></h6>'+
            '<h6 style="margin-right: 152px;">Correo Electrónico: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.correo +'</small></span></h6>',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
            this.loaderFacturar = true;
            this.factura.puede = false;
            this.factura.horas = this.$horas();
            const envio = JSON.parse(JSON.stringify(this.factura));
            envio.idDatosFiscales = this.factura.idDatosFiscales.idDatosFiscales
            this.$http
            .post(this.$api + "facturacion/timbrar", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                if (respuesta.data.data.includes("exito")) {
                  const mensaje = respuesta.data.data;
                  const array = mensaje.split("|");
                  this.idFactura = array[1];
                  this.$swal.fire({
                    icon: "success",
                    title: "¡Muy Bien!",
                    text: "Se generó la factura correctamente",
                  });
                  this.showModalFactura = false;
                  this.obtenerInformacionRecibo();
                  this.imprimirFactura();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Aviso",
                    html: respuesta.data.data,
                  });
                  this.obtenerFacturas();
                }
              }
            })
            .finally(() => {
              this.loaderFacturar = false;
            });
          }
        });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Seleccione el/los recibos a facturar",
        });
      }
    },
    cerrarPago() {
      this.$http
          .post(this.$api + "sesion/buscarSesionActiva", this.idSesion)
          .then(respuesta => {
            if (respuesta.data.data) {
              const parametros = {
                idSesion: this.idSesion, 
                comentarios: "CIERRE DE SESION POR MEDIO DEL PAGO SESION",
                idPaciente: this.idPaciente
              }
              this.$http
                  .post(this.$api + "agenda/cerrarSesion", parametros)
                  .then((response) => {
                    if (response.status === 200) {
                      this.$router.push({name: 'dashboard'});
                    }
                  })
                  .catch((error) => {
                    console.error(error)
                    this.$swal({
                      icon: "error",
                      title: "Error al cerrar sesion",
                      text: error.response.data.message,
                      confirmButtonText: "OK",
                      confirmButtonColor: "#0e6ba9",
                    });
                  })
            } else {
              this.$router.push({name: 'dashboard'});
            }
          })

    }


  },
  watch: {
    "datoFiscal.cp": function () {
      if (this.datoFiscal.cp.length === 5) {
        this.tieneCp = true;
        this.buscarCp();
      } else {
        this.tieneCp = false;
        this.localidades = [];
        this.datoFiscal.colonia = null;
        this.datoFiscal.estado = null;
        this.datoFiscal.pais = null;
      }
    },
  },
}
</script>

<style scoped>
.title{
  color: #006AAA;
  font-weight: 600;
  font-size: 1em;
}

.success{
  color: #21C63F;
  font-weight: 600;
  font-size: 1em;
  
}
.card-caja {
  background: #f6f6f6;
  border: none;
}



.btn-primary {
  color: #FFF;
  background-color: #1B81AF;
}

.btn-primary:hover {
  color: #1B81AF;
  background-color: #FFF;
}

.main-container{
     background-color: white;
      width: 80% !important;
      height: auto;
      margin-top: 4%;
      border-radius: 20px;
      margin-bottom: -4%;
  }

 .btns-apilados{
    line-height: 3;
  }

@media (max-width: 600px){
  .main-container{
    background-color: white;
    width: 98% !important;
    height: 120vh;
    margin-top: 1%;
    border-radius: 20px;
  }

  .borde-izq{
    border-left: 0px solid #EEEEEE;
    padding-left: 0%;
  }

  .btn-caja{
    width: 80%;
  }
  .btns-apilados{
    margin-top: 5%;
    
  }
  
}

@media (min-width: 600px) and (max-width: 990px){
    .main-container{
  background-color: white;
  width: 95% !important;
  height: 100vh;
  margin-top: 1%;
  border-radius: 20px;
  }

  .btn-caja{
    width: 12em;
  }

  .btns-apilados{
    margin-top: 5%;
  }
  .borde-izq{
    border-left: 0px solid #EEEEEE;
    padding-left: 0%;
  }
}

@media (min-width: 991px) and (max-width: 1950px){
  .borde-izq{
     border-left: 1px solid #EEEEEE;
    padding-left: 3%;
  }

  .btn-cerrarPago{
    margin-right: 3%;
  }

  .btn-caja{
    width: 12em;
  }

  .btns-apilados{
    margin-top: 5%;
    
  }
  .main-container{
  background-color: white;
  width: 66% !important;
  height: 90vh;
  margin-top: 4%;
  border-radius: 20px;
}
}

@media (min-width: 1951px){
  .borde-izq{
     border-left: 2px solid #EEEEEE;
    padding-left: 3%;
  }

    .main-container{
    background-color: white;
    width: 66% !important;
    height: 70vh;
    margin-top: 4%;
    border-radius: 20px;

  }

  .btn-caja{
    width: 12em;
  }

  .btns-apilados{
    margin-top: 5%;
    
  }
}
</style>